import { PUBLIC_LOCAL, PUBLIC_WT3_BASE_URL } from '$env/static/public'
import { v4 as uuidv4 } from 'uuid'
import { storeCustomerInfo, storeCustomerToken } from '$lib/js/stores'
import { get } from 'svelte/store'
import type { CustomerToken } from '../magento/types'
import { getCustomerInfo } from '../magento/account/account'
import { getCustomerToken } from '../magento/cart/cart'
import { is_set_object } from '.'
// Simple variable to store current page ID
let currentPageId: string | null = null
let customerInitialized = false

export async function getCustomer(cacheOnly:boolean) {
	let customerInfo = get(storeCustomerInfo)

	if (!customerInitialized && !cacheOnly && !is_set_object(customerInfo)  ) {
		let token: CustomerToken | null = get(storeCustomerToken)
		// If is the first time we load and there's no token stored

		if (token && token.token) {
			customerInfo = await getCustomerInfo(token.token)

			storeCustomerInfo.set(customerInfo)
		}
    customerInitialized = true
	}


	return customerInfo
}


export async function sendWT3(
	eventType?: string,
	eventData?: Record<string, any>,
	options?: {
		pageUrl?: Location;
		referrer?: string | null;
		timestamp?: number;
	},
) {
	if (!PUBLIC_LOCAL || parseInt(PUBLIC_LOCAL) !== 1) {
		const finalEventType = eventType || 'page_view'
		let pageId: string
		// Generate new page ID for page views, reuse existing for other events
		if (finalEventType === 'page_view') {
			pageId = uuidv4()
			currentPageId = pageId // Store it
		} else {
			pageId = currentPageId || uuidv4() // Reuse or fallback
		}
		// Access store values
		const customerInfo = finalEventType=='page_view' ? await getCustomer(false) : getCustomer(true)
		const payload = {
			event_type: finalEventType,
			event_data: {
				...eventData,
				page_id: pageId,
				// Add store data to event_data
				customer_info: customerInfo,
			},
			page_url: options?.pageUrl || (typeof window !== 'undefined' ? window.location : null),
			referrer: options?.referrer || null,
			timestamp: options?.timestamp || Date.now(),
		}
		return fetch(`${PUBLIC_WT3_BASE_URL}/rec`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		})
	}
}
